import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { ArrowLeft, KeyRound, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("La confirmation ne correspond pas"); return; }
    if (pw.length < 6) { toast.error("6 caractères minimum"); return; }
    if (!token) { toast.error("Lien invalide"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: pw });
      toast.success("Mot de passe réinitialisé — connectez-vous !");
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur lors de la réinitialisation");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-white text-[#1a2332] font-body" data-testid="reset-password-page">
      <div className="lg:w-1/2 relative overflow-hidden p-8 lg:p-16 flex flex-col justify-between bg-[#080C0E] text-white">
        <Link to="/login" className="inline-flex items-center gap-2 text-white/70 hover:text-white w-fit" data-testid="back-login">
          <ArrowLeft className="w-4 h-4" /> Retour à la connexion
        </Link>
        <div>
          <img src="/brand/logo.png" alt="DDSEmpire" className="w-16 h-16 rounded-xl object-contain" />
          <h1 className="mt-8 font-headings font-black text-4xl md:text-5xl leading-tight">Nouveau<br />mot de passe.</h1>
          <p className="mt-5 text-white/65 max-w-md text-lg">Choisissez un mot de passe robuste (6 caractères minimum, idéalement 10+).</p>
        </div>
        <div className="text-xs text-white/50">
          DDSEmpire · 01 41 31 50 61
        </div>
      </div>

      <div className="lg:w-1/2 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="reset-form">
          <div className="w-12 h-12 rounded-xl bg-[#FF8C42]/10 text-[#FF8C42] flex items-center justify-center">
            <KeyRound className="w-6 h-6" />
          </div>
          <h2 className="mt-5 font-headings font-black text-3xl">Nouveau mot de passe</h2>
          <p className="mt-2 text-[#5b6577]">Votre nouveau mot de passe sera actif immédiatement.</p>

          {!token && (
            <div className="mt-5 rounded-xl bg-[#e21b3c]/10 border border-[#e21b3c]/20 text-[#e21b3c] p-4 text-sm">
              Lien invalide. Demandez un nouveau lien depuis « Mot de passe oublié ».
            </div>
          )}

          <label className="block mt-6">
            <span className="font-headings font-semibold text-sm">Nouveau mot de passe</span>
            <input type="password" autoComplete="new-password" required minLength={6} value={pw}
              onChange={(e) => setPw(e.target.value)} data-testid="reset-password-new"
              className="mt-2 w-full rounded-xl border-2 border-[#e5eaf3] focus:border-[#00a86b] outline-none px-4 py-3 font-body" placeholder="6 caractères minimum" />
          </label>
          <label className="block mt-4">
            <span className="font-headings font-semibold text-sm">Confirmation</span>
            <input type="password" autoComplete="new-password" required minLength={6} value={confirm}
              onChange={(e) => setConfirm(e.target.value)} data-testid="reset-password-confirm"
              className="mt-2 w-full rounded-xl border-2 border-[#e5eaf3] focus:border-[#00a86b] outline-none px-4 py-3 font-body" />
          </label>

          <button type="submit" disabled={loading || !token} data-testid="reset-submit"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#FF8C42] hover:bg-[#e8763a] disabled:opacity-60 text-white font-headings font-bold rounded-xl px-7 py-3.5 shadow-lg transition-all">
            {loading ? "Enregistrement…" : (<><Check className="w-4 h-4" /> Enregistrer</>)}
          </button>
        </form>
      </div>
    </div>
  );
}
